<template>
  <div class="workspace" v-if="show_data">
    <div ref="map"></div>
    <data-view-sidebar :isSidebarActive="addNewDataSidebar" @closeSidebar="toggleDataSidebar" :data="sidebarData" />
    <div class="section-heading">
      <h2>Restaurant Settings</h2>
    </div>
    <div v-if="selectedRestaurant" class="setting-main-cont">
      <form class="setting-cont"
            data-vv-scope="ownerinfo">

        <div class="setting-heading">
          <h3>Owner Info</h3>
        </div>
        <div class="setting-inner">
          <div class="setting-row">
            <div class="setting-column">
              <h4>Name</h4>
              <input class="tr-input" type="text" v-model="name"
                     v-validate="'required'"
                     @input="formChange('ownerinfo')"
                     data-vv-as="Name"
                     name="Name"/>

              <span v-show="errors.has('ownerinfo.Name')" class="text-danger">{{ errors.first('ownerinfo.Name') }}</span>

            </div>
            <div class="setting-column">
              <h4>Last Name</h4>
              <input class="tr-input" type="text" v-model="last_name"
                     v-validate="'required'"
                     @input="formChange('ownerinfo')"
                     data-vv-as="Last Name"
                     name="Last Name"/>

              <span v-show="errors.has('ownerinfo.Last Name')" class="text-danger">{{ errors.first('ownerinfo.Last Name') }}</span>

            </div>
          </div>
          <div class="setting-row">
            <div class="setting-column">
              <h4>Email</h4>
              <input class="tr-input" @input="formChange('ownerinfo')" type="email" v-model="email"/>
            </div>
            <div class="setting-column">
              <h4>Phone</h4>
              <input class="tr-input" type="tel" v-model="phone"  v-validate="'required'"
                     data-vv-as="Phone"
                     @input="formChange('ownerinfo')"
                     name="Phone"/>

              <span v-show="errors.has('ownerinfo.Phone')" class="text-danger">{{ errors.first('ownerinfo.Phone') }}</span>
            </div>
          </div>
          <div class="setting-row">
            <div class="setting-column">

              <div v-if="changePass">
                <div>
                  <h4 >New Password</h4>
                </div>
                <span v-show="errors.has('ownerinfo.newpassword')" class="text-danger">{{ errors.first('ownerinfo.newpassword') }}</span>
                <input
                  data-vv-as="Password"
                  name="newpassword"
                  id="newpassword"
                  v-model="newpassword"
                  type="password"
                  placeholder="Password"
                  @input="formChange('ownerinfo')"
                  v-validate="'required'"
                  class="tr-form-control tr-input"
                />
              </div>

<h4 v-if="!changePass">Password</h4>
  <div v-if="!changePass" class="tr-button warning-button" @click="changePass = !changePass"><i class="fas fa-unlock"></i> Change</div>
  <div v-else class="tr-button delete-button" @click="changePass = !changePass">Cancel</div>
            </div>
          </div>
        </div>
        <div class="tr-button green-button" :class="(part1change) ? '' : 'inactive'" @click.prevent="submitUserForm('ownerinfo')">Save Settings</div>

      </form>
      <form class="setting-cont"
            data-vv-scope="socials">
        <div class="setting-heading">
          <h3>Social Platforms</h3>
        </div>
        <div class="setting-inner">
          <div class="setting-row">
            <div class="setting-column">
              <h4>Instagram</h4>
              <input class="tr-input" type="text" @input="formChange('socials')" v-model="instagram"/>
            </div>
            <div class="setting-column">
              <h4>Facebook</h4>
              <input class="tr-input" type="text" @input="formChange('socials')" v-model="facebook"/>
            </div>
          </div>
          <div class="setting-row">

            <div class="setting-column">
              <h4>Twitter</h4>
              <input class="tr-input" type="text" @input="formChange('socials')" v-model="twitter"/>
            </div>
            <div class="setting-column">
              <h4>Website</h4>
              <input class="tr-input" type="text" @input="formChange('socials')" v-model="website"/>
            </div>
          </div>
        </div>
        <div class="tr-button green-button " :class="(part2change) ? '' : 'inactive'" @click.prevent="submitUserForm('socials')">Save Settings</div>
      </form>
      <form class="setting-cont"
      data-vv-scope="restaurantinfo">
        <div class="setting-heading">
          <h3>Restaurant Info</h3>
        </div>
        <div class="setting-inner">
          <div class="setting-row">
            <div class="setting-column full-width">
                <h4>Google Place ID</h4>
                  <div v-if="google_places_id" class="google-place-id">{{google_places_id}}</div>
              <div class="setting-column full-width mt-2">
                <h4>Restaurant Address</h4>
                <div @input="formChange('restaurantinfo')">{{restaurant_address}}</div>
              </div>
              <div class="setting-column full-width">
                <label class="al-label">
                  Business Address
                  <places :location="business_address" :placeholder="business_address" :found="placesFound" class="w-full"></places>
                </label></div>
              <div class="setting-row mt-2">
                <div class="setting-column"><label class="al-label">
                  Street
                  <input class="tr-input" type="text" v-model="address_line1" @input="address_change" placeholder="Apt/Unit" />
                </label></div><div class="setting-column"><label class="al-label">
                  Apt/Unit
                  <input class="tr-input" type="text" v-model="address_line2" @input="address_change" placeholder="Apt/Unit" />
                </label></div>
              </div>
              <div class="setting-row">
                <div class="setting-column"><label class="al-label">
                  City
                  <input class="tr-input" @input="address_change" v-model="city" type="text" placeholder="City" />
                </label></div>
                <div class="setting-column"><label class="al-label">
                  State/County/Region
                  <input class="tr-input" @input="address_change" type="text" placeholder="State"  v-model="state"/>
                </label></div>
              </div>
              <div class="setting-row">
                <div class="setting-column"><label class="al-label">
                  ZIP/Postcode
                  <input class="tr-input" type="text" @input="address_change" v-model="zipcode" placeholder="11111" />
                </label></div>
                <div class="setting-column"></div>
              </div>
            </div>
          </div>
          <div class="setting-row  no-justify">
            <div class="setting-column">
              <h4>Restaurant Cover</h4>
              <img class="cover-image" :src="dataImg" />
              <div class="tr-upload tr-button" for="tr-image-upload" @click="$refs.uploadImgInput.click()">Upload Image</div>

              <input id="tr-image-upload" type="file" class="hidden" ref="uploadImgInput" @change="updateCurrImg" accept="image/*">
            </div>
            <div class="setting-column">

              <h4>Restaurant Logo</h4>
              <img class="cover-image" :src="logoImg" />
              <div class="tr-upload tr-button" for="tr-image-upload" @click="$refs.uploadLogoInput.click()">Upload Logo</div>

              <input id="tr-logo-upload" type="file" class="hidden" ref="uploadLogoInput" @change="updateCurrLogo" accept="image/*">
            </div>
          </div>
          <div class="setting-row">
            <div class="setting-column">
              <h4>Restaurant Name</h4>
              <input class="tr-input" type="text"  @input="formChange('restaurantinfo')" v-model="restaurant_name" />
            </div>
          </div>
          <div class="setting-row">
            <div class="setting-column">
              <h4>Custom URL</h4>
              <input class="tr-input" type="text" @input="formChange('restaurantinfo')" v-model="restaurant_alias"/>
            </div>
          </div>
          <div class="setting-row">
            <div class="setting-column full-width">
              <h4>About Restaurant</h4>
              <textarea class="tr-input tr-textarea" @input="formChange('restaurantinfo')" v-model="about"></textarea>
            </div>
          </div>

          <div class="setting-row">
            <div>
              <h4>Visible</h4>
              <div>
                <input type="checkbox" id="visibleRestaurant" name="visibleRestaurant" v-model="visibleRestaurant" value="true" @input="formChange('restaurantinfo')">
                <label class="pop-radio-label" for="visibleRestaurant">Restaurant Show</label>
              </div>
            </div>
          </div>
          <div class="setting-row">
            <div>
              <h4>Delivery</h4>
              <div>
                <input type="checkbox" id="doorDash" name="doorDash" v-model="doorDash" value="true" @input="formChange('restaurantinfo')">
                <label class="pop-radio-label" for="doorDash">DoorDash Delivery</label>
              </div>
            </div>
          </div>
          <div class="setting-row">
            <div>
              <h4>Tag</h4>
              <div>
                <vue-tags-input
                    v-model="tag"
                    :tags="tags"
                    :add-on-key="[13, ':', ';', ',']"
                    @tags-changed="newTags => {
                      tags = newTags
                      formChange('restaurantinfo')
                    }"
                />
              </div>
            </div>
          </div>
        </div>
        <div class="tr-button green-button" :class="(part3change) ? '' : 'inactive'" @click.prevent="submitUserForm('restaurantinfo')">Save Settings</div>
      </form>
      <form class="setting-cont"
      data-vv-scope="paymentinfo" v-if="userInfo.user_group===4">
        <div class="setting-heading">
          <h3>Payment Settings</h3>
        </div>
        <div class="setting-inner">

          <h4>Account Status:</h4>
          <div class="setting-row" v-if="stripeAccount !== null">
            <div class="setting-column">
              <div >{{ accountStatus }} {{(stripeAccount.business_profile) ? ((stripeAccount.business_profile.mcc) ? stripeAccount.business_profile.mcc : 'Please complete account creation.') : 'Please complete account creation.'}}</div>
              <div class="mt-2 text-capitalize">Payout Schedule: <br/>
                <div v-if="stripeAccount.settings.payouts.schedule.interval === 'daily'">every {{stripeAccount.settings.payouts.schedule.delay_days}} days </div>
                <div v-else-if="stripeAccount.settings.payouts.schedule.interval === 'weekly'">every {{stripeAccount.settings.payouts.schedule.weekly_anchor}} </div>
                <div v-else>Not available</div>
              </div>
            </div>
            <div class="setting-column">
              <div>Charges: {{charges_enabled ? 'Enabled' : 'Restricted'}}</div>
              <div class="mt-2">Payouts: {{payouts_enabled ? 'Enabled' : 'Restricted'}}</div>
            </div>
          </div>
          <div class="setting-row" v-if="selectedCard">
            <div>Bank Account: {{ selectedCard.bank_name }} card ends with {{selectedCard.last4}}</div>
          </div>
          <div class="setting-row">

            <div class="setting-column w-full">
              <div class="mt-2" v-if="!has_account">
                <div class="tr-button green-button" @click="createPaymentAccount">Create Payment Account</div>
                <div>By registering your account, you agree to our Services Agreement and the
                  <a class="agreement-link" href="https://stripe.com/connect-account/legal/recipient" target="_blank">
                    Stripe Recipient Agreement</a></div>
              </div>
              <div v-else>
                <div v-if="has_account && !charges_enabled">
                  <div class="tr-button green-button" @click="createPaymentAccount">Continue to Payment Account</div>
                </div>
                <div v-if="(has_account && charges_enabled && !payouts_enabled && !selectedCard)">
                  <form data-vv-scope="bankaccount">
                    <div class="setting-row">
                      <div class="setting-column">
                        <h4>Account Holder Name</h4>
                        <input class="tr-input" type="text"
                               v-validate="'required'"
                               data-vv-as="Account Holder Name"
                               v-model="account_holder_name"
                               name="Account Holder Name"/>

                        <span v-show="errors.has('bankaccount.Account Holder Name')" class="text-danger">{{ errors.first('bankaccount.Account Holder Name') }}</span>

                      </div>
                      <div class="setting-column">
                        <h4>Account Number</h4>
                        <input class="tr-input" type="text"
                               v-validate="'required'"
                               data-vv-as="Account Number"
                               v-model="account_number"
                               name="Account Number"/>
                        <span v-show="errors.has('bankaccount.Account Number')" class="text-danger">{{ errors.first('bankaccount.Account Number') }}</span>

                      </div>

                    </div>
                    <div class="setting-row">
                      <div class="setting-column">
                        <h4>Routing Number</h4>
                        <input class="tr-input" type="text"
                               v-validate="'required'"
                               v-model="routing_number"
                               data-vv-as="Routing Number"
                               name="Routing Number"/>
                        <span v-show="errors.has('bankaccount.Routing Number')" class="text-danger">{{ errors.first('bankaccount.Routing Number') }}</span>

                      </div>
                      <div class="setting-column relative ">

                        <div class="padded tr-button green-button absolute bottom-0" @click="addBankAccount">Save</div>
                      </div>
                    </div>
                  </form>
                </div>
                <div v-else-if="has_account && stripeAccount.business_profile">
                  <div v-if="stripeAccount.business_profile.mcc">
                    <form data-vv-scope="bankaccount" v-if="bankToggle">
                      <div class="setting-row">
                        <div class="setting-column">
                          <h4>Account Holder Name</h4>
                          <input class="tr-input" type="text"
                                 v-validate="'required'"
                                 data-vv-as="Account Holder Name"
                                 v-model="account_holder_name"
                                 name="Account Holder Name"/>

                          <span v-show="errors.has('bankaccount.Account Holder Name')" class="text-danger">{{ errors.first('bankaccount.Account Holder Name') }}</span>

                        </div>
                        <div class="setting-column">
                          <h4>Account Number</h4>
                          <input class="tr-input" type="text"
                                 v-validate="'required'"
                                 data-vv-as="Account Number"
                                 v-model="account_number"
                                 name="Account Number"/>
                          <span v-show="errors.has('bankaccount.Account Number')" class="text-danger">{{ errors.first('bankaccount.Account Number') }}</span>

                        </div>

                      </div>
                      <div class="setting-row">
                        <div class="setting-column">
                          <h4>Routing Number</h4>
                          <input class="tr-input" type="text"
                                 v-validate="'required'"
                                 v-model="routing_number"
                                 data-vv-as="Routing Number"
                                 name="Routing Number"/>
                          <span v-show="errors.has('bankaccount.Routing Number')" class="text-danger">{{ errors.first('bankaccount.Routing Number') }}</span>

                        </div>
                        <div class="setting-column relative ">
                          <div class="flex absolute bottom-0">
                            <div class="padded tr-button green-button " @click="addBankAccount">Save</div>
                            <div class="padded  tr-button inactive ml-2" @click="bankToggle = !bankToggle">Close</div>
                          </div>
                        </div>
                      </div>
                    </form>
                    <div v-if="!bankToggle" class="tr-button green-button mt-2" @click="bankToggle = !bankToggle">Add a Bank Account</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="setting-row">
            <div>
              <h4>Payment Model</h4>
              <div>
                <input type="radio" id="commission" name="paymentModel" v-model="paymentModel" value="commission" @change="changePaymentModelService"><label class="pop-radio-label" for="commission">Commission Based</label>
              </div>
              <div>
                <input type="radio" id="subscription" name="paymentModel" v-model="paymentModel" value="subscription" @change="changePaymentModelService"><label class="pop-radio-label" for="subscription">Subscription Based</label>
              </div>
            </div>
          </div>

          <div class="setting-row">
            <div class="setting-column">
              <h4>TAX Rate</h4>
              <input class="tr-input" type="text" @input="formChange('paymentinfo')" v-model="tax" />
            </div>
          </div>
          <div class="setting-row">
            <div class="setting-column">
              <h4>Send System Emails To:</h4>
              <input class="tr-input" type="email" @input="formChange('paymentinfo')" v-model="email_receipents"/>
            </div>
          </div>
        </div>
        <div class="tr-button green-button" :class="(part4change) ? '' : 'inactive'" @click.prevent="submitUserForm('paymentinfo')">Save Settings</div>
      </form>
      <div class="setting-cont" v-if="userInfo.user_group===4">
        <div class="setting-heading">
          <h3>Multiple Location Settings</h3>
        </div>
        <div class="setting-inner">
          <p>You can duplicate your restaurant if you have more than one location. This option allows you to set up your new location faster.<br><br> Your menu and images will carry over into new duplication.

            You still need to fill out a new business form for a new location.<br><br></p>
          <div @click="duplicateData()" class="tr-button green-button">Duplicate My Restaurant</div>

        </div>

      </div>
    </div>
    <div v-else><h3>Select any restaurant to continue</h3></div>
  </div>
</template>
<script>
import { mapState, mapActions } from 'vuex'
import Places from '../../../components/google-places/Places'
import DataViewSidebar from './DataViewSidebar'
import VueTagsInput from '@johmun/vue-tags-input'

export default{
  props: {},
  components: {
    Places,
    DataViewSidebar,
    VueTagsInput
  },
  data () {
    return {
      show_data: false,
      addNewDataSidebar: false,
      sidebarData: {},
      changePass: false,
      part1change: false,
      part2change: false,
      part3change: false,
      part4change: false,
      bankToggle: false,
      stripeAccount: null,
      selectedCard: null,
      accountStatus: '',
      password: '',
      newpassword: '',
      newpassword2: '',
      name: '',
      last_name: '',
      email: '',
      phone: '',
      google_places_id: '',
      restaurant_name: '',
      restaurant_address: '',
      restaurant_alias: '',
      about: '',
      instagram: '',
      facebook: '',
      twitter: '',
      website: '',
      tax: '',
      paymentModel: '',
      commission: '',
      email_receipents: '',
      dataImg: null,
      logoImg: null,
      uploadImg: null,
      has_account: false,
      charges_enabled: false,
      payouts_enabled: false,
      has_payment_method: false,
      account_number: '',
      routing_number: '',
      account_holder_name: '',
      location: null,
      business_address: '',
      address_line1: '',
      address_line2: '',
      city: '',
      state: '',
      zipcode: '',
      placeService: null,
      visibleRestaurant: false,
      doorDash: false,
      tag: '',
      tags: []
    }
  },
  computed: {
    ...mapState('user', ['user']),
    userInfo () {
      return this.$store.state.api.currentUser
    },
    reservationData () {
      return this.$store.state.api.reservationData
    },
    selectedRestaurant () {
      let obj = this.$store.state.api.selectedRestaurant
      if (!obj) {
        try {
          obj = JSON.parse(localStorage.getItem('selectedRestaurant'))
        } catch (e) {
          obj = null
        }

      }
      return obj
    }
  },
  methods: {
    ...mapActions('user', ['changePaymentModel', 'getRestaurant']),
    async getRestaurantData (restaurantId) {
      await this.getRestaurant({payload: {restaurantId}})
      this.$store.commit('api/SET_SELECTED_RESTAURANT', this.user)

    },
    async changePaymentModelService () {
      this.$vs.loading()
      await this.changePaymentModel({payload: {
        paymentModel: this.paymentModel,
        restaurantId: this.selectedRestaurant.id
      }})
      this.$vs.loading.close()
    },
    initPlaces () {
      this.placeService = new window.google.maps.places.PlacesService(this.$refs.map)
    },
    address_change () {
      this.restaurant_address = `${this.address_line2} ${this.address_line1}, ${this.city}, ${this.state} ${this.zipcode}`

      this.part3change = true
    },
    toggleDataSidebar (val = false) {
      this.addNewDataSidebar = val

      if (val === false) {
        this.getUserList(this.user_group)
        this.$store.dispatch('api/setPropertyListForUser', {})
      }
    },
    addBankAccount () {
      this.$validator.validateAll('bankaccount').then(result => {
        if (result) {
          this.$vs.loading()

          const payload = {
            restaurant_id: this.selectedRestaurant.id,
            account_holder_name: this.account_holder_name,
            routing_number: this.routing_number,
            account_number: this.account_number
          }

          this.$store.dispatch('api/addBankAccount', payload).then((response) => {
            this.$vs.notify({
              title: 'Success',
              text: response.data.message,
              iconPack: 'feather',
              icon: 'icon-check',
              color: 'success'
            })
            this.$vs.loading.close()
            location.reload()
          }).catch(err => {
            console.error(err.response)
            this.$vs.loading.close()
            this.$vs.notify({
              title: 'Error',
              text: err.response.data.message,
              iconPack: 'feather',
              icon: 'icon-alert-circle',
              color: 'danger'
            })
          })
        } else {
          this.$vs.notify({
            title: 'Error',
            text: 'Please enter valid details',
            color: 'warning',
            iconPack: 'feather',
            icon: 'icon-alert-circle'
          })
        }
      })
    },
    submitUserForm (form_name) {
      switch (form_name) {
      case 'ownerinfo':
        if (this.part1change) {
          this.$validator.validateAll(form_name).then(result => {
            if (result) {

              this.$vs.loading()
              const payload = {
                user_id: this.selectedRestaurant.id,
                name: this.name,
                email: this.email,
                last_name: this.last_name,
                phone: this.phone,
                user_group: 2,
                redirectVerifyMailUrl: 'https://restadmin.turkishrestaurant.com/verify-mail/{token}',
                redirectSecureMailUrl: 'https://restadmin.turkishrestaurant.com/reset-password/{token}'
              }

              this.$store.dispatch('api/updateUserJWT', payload).then((response) => {
                if (this.newpassword !== '') {
                  const pass_payload = {
                    restaurantId: this.selectedRestaurant.id,
                    password: this.newpassword
                  }
                  this.$store.dispatch('api/changeUserPassword', pass_payload).then((response) => {
                    this.openAlert(response.data.message)
                    this.resetFormChange(form_name)
                    this.handleData()
                    this.$vs.loading.close()
                  }).catch(err => {
                    console.error(err.message)
                    this.$vs.loading.close()
                    this.openAlert(err.message)
                  })
                } else {

                  this.openAlert(response.data.message)
                  this.handleData()
                  this.resetFormChange(form_name)
                  this.$vs.loading.close()
                }
              }).catch(err => {
                this.$vs.loading.close()
                this.openAlert(err.message)
              })
            } else {
              this.openAlert('Please enter valid details')
            }
          })
        }
        break
      case 'socials':
        if (this.part2change) {
          this.$validator.validateAll(form_name).then(result => {
            if (result) {

              this.$vs.loading()
              const payload = {
                user_id: this.selectedRestaurant.id,
                email: this.email,
                name: this.selectedRestaurant.name,
                phone: this.selectedRestaurant.phone,
                last_name: this.selectedRestaurant.last_name,
                user_group: 2,
                property: {
                  'Twitter': this.twitter,
                  'Instagram': this.instagram,
                  'Facebook': this.facebook,
                  'Website': this.website
                }
              }

              this.$store.dispatch('api/updateUserJWT', payload).then((response) => {
                this.openAlert(response.data.message)
                this.resetFormChange(form_name)
                this.handleData()
                this.$vs.loading.close()
              }).catch(err => {
                console.error(err.message)
                this.$vs.loading.close()
                this.$vs.notify({
                  title: 'Error',
                  text: err.message,
                  iconPack: 'feather',
                  icon: 'icon-alert-circle',
                  color: 'danger'
                })
              })

            } else {
              this.$vs.notify({
                title: 'Error',
                text: 'Please enter valid details',
                color: 'warning',
                iconPack: 'feather',
                icon: 'icon-alert-circle'
              })
            }
          })
        }
        break
      case 'restaurantinfo':
        if (this.part3change) {
          this.$validator.validateAll(form_name).then(result => {
            if (result) {
              /*if (this.tags.length > 0) {
                for (const [index, tag] of Object.values(this.tags).entries()) {

                }
              }*/


              this.$vs.loading()
              const payload = {
                user_id: this.selectedRestaurant.id,
                email: this.email,
                name: this.selectedRestaurant.name,
                phone: this.selectedRestaurant.phone,
                last_name: this.selectedRestaurant.last_name,
                user_group: 2,
                property: {
                  'About': this.about,
                  'Restaurant-Name': this.restaurant_name,
                  'Address': this.restaurant_address,
                  'Address-1': this.address_line1,
                  'Address-2': this.address_line2,
                  'City': this.city,
                  'State': this.state,
                  'Zip-Code': this.zipcode,
                  'Alias': this.restaurant_alias,
                  'Google-Places-ID': this.google_places_id,
                  'Location': this.location,
                  'visible': this.visibleRestaurant,
                  'DoorDash': this.doorDash,
                  'Tags': JSON.stringify(this.tags)
                }
              }

              this.$store.dispatch('api/updateUserJWT', payload).then((response) => {
                this.openAlert(response.data.message)
                this.resetFormChange(form_name)
                this.handleData()
                this.$vs.loading.close()
              }).catch(err => {
                console.error(err.message)
                this.$vs.loading.close()
                this.$vs.notify({
                  title: 'Error',
                  text: err.message,
                  iconPack: 'feather',
                  icon: 'icon-alert-circle',
                  color: 'danger'
                })
              })

            } else {
              this.$vs.notify({
                title: 'Error',
                text: 'Please enter valid details',
                color: 'warning',
                iconPack: 'feather',
                icon: 'icon-alert-circle'
              })
            }
          })
        }
        break
      case 'paymentinfo':
        if (this.part4change) {
          this.$validator.validateAll(form_name).then(result => {
            if (result) {

              this.$vs.loading()
              const payload = {
                user_id: this.selectedRestaurant.id,
                email: this.email,
                name: this.selectedRestaurant.name,
                phone: this.selectedRestaurant.phone,
                last_name: this.selectedRestaurant.last_name,
                user_group: 2,
                property: {
                  'tax': this.tax,
                  'Order-Notifications': this.email_receipents
                }
              }

              this.$store.dispatch('api/updateUserJWT', payload).then((response) => {
                this.openAlert(response.data.message)
                this.resetFormChange(form_name)

                this.handleData()
                this.$vs.loading.close()
              }).catch(err => {
                console.error(err.message)
                this.$vs.loading.close()
                this.$vs.notify({
                  title: 'Error',
                  text: err.message,
                  iconPack: 'feather',
                  icon: 'icon-alert-circle',
                  color: 'danger'
                })
              })

            } else {
              this.$vs.notify({
                title: 'Error',
                text: 'Please enter valid details',
                color: 'warning',
                iconPack: 'feather',
                icon: 'icon-alert-circle'
              })
            }
          })
        }
        break
      }
    },
    openAlert (text) {
      this.$vs.dialog({
        type:'alert',
        color: 'success',
        clickNotClose: true,
        title: 'Confirm',
        acceptText: 'Ok',
        text
      })
    },
    resetFormChange (form_name) {
      switch (form_name) {
      case 'ownerinfo':
        this.part1change = false
        break
      case 'socials':
        this.part2change = false
        break
      case 'restaurantinfo':
        this.part3change = false
        break
      case 'paymentinfo':
        this.part4change = false
        break
      }
    },
    formChange (form_name) {
      switch (form_name) {
      case 'ownerinfo':
        this.part1change = true
        break
      case 'socials':
        this.part2change = true
        break
      case 'restaurantinfo':
        this.part3change = true
        break
      case 'paymentinfo':
        this.part4change = true
        break
      }
    },
    handleData () {

      this.$vs.loading()
      const {name, last_name, email, phone, user_property, photoUrl} = this.selectedRestaurant
      this.name = name
      this.last_name = last_name
      this.email = email
      this.phone = phone
      this.google_places_id = user_property['Google-Places-ID']
      this.restaurant_name = user_property['Restaurant-Name']
      this.visibleRestaurant = user_property['visible'] ? user_property['visible'] : false
      this.doorDash = user_property['DoorDash'] ? user_property['DoorDash'] : false
      this.tags = user_property['Tags'] ? JSON.parse(user_property['Tags']) : []
      this.restaurant_address = user_property['Address']
      this.address_line1 = user_property['Address-1']
      this.address_line2 = user_property['Address-2']
      this.city = user_property['City']
      this.state = user_property['State']
      this.zipcode = user_property['Zip-Code']
      this.restaurant_alias = user_property['Alias']
      this.about = user_property['About']
      this.instagram = user_property['Instagram']
      this.twitter = user_property['Twitter']
      this.website = user_property['Website']
      this.facebook = user_property['Facebook']
      this.tax = user_property['tax']
      this.email_receipents = user_property['Order-Notifications']
      this.location = user_property['Location']

      this.dataImg = (photoUrl !== null) ? photoUrl : 'img/placeholder.jpg'
      this.logoImg = (user_property['Logo'] !== null) ? user_property['Logo'] : 'img/placeholder.jpg'

      this.getStripeAccount()
      setTimeout(() => {
        this.$vs.loading.close()
      }, 1000)
    },
    changePlace () {
      this.google_places_id = null
    },
    getPlaceDetails (place_id, callback) {
      const self = this
      this.placeService.getDetails({placeId: place_id}, function (PlaceResult) {
        // PlaceResult is an object
        // PlacesServiceStatus is a string
        self.selectedPlace = PlaceResult
        callback(PlaceResult)
      })
    },
    placesFound (value) {
      this.business_address = value.description
      this.address_line1 = value.terms[1].value
      this.state = value.terms[3].value
      this.city = value.terms[2].value
      const self = this

      this.google_places_id = value.place_id
      this.part3change = true
      this.getPlaceDetails(value.place_id, (PlaceResult) => {
        let adress_result = ''
        PlaceResult.address_components.filter(component => {
          if (component.types.includes('street_number')) {
            adress_result = component.long_name
            this.address_line2 = adress_result
          }
          if (component.types.includes('administrative_area_level_1')) {
            adress_result = component.short_name
            this.state = adress_result
          }
        })
        this.location = {
          lat: PlaceResult.geometry.location.lat(), lng: PlaceResult.geometry.location.lng()
        }
        self.zipcode = PlaceResult.address_components.filter(comp => comp.types.includes('postal_code'))[0].long_name

        this.restaurant_address = `${this.address_line2} ${this.address_line1}, ${this.city}, ${this.state} ${this.zipcode}`
      })
    },
    updateCurrImg (input) {
      if (input.target.files && input.target.files[0]) {
        const reader = new FileReader()
        reader.onload = e => {
          this.dataImg = e.target.result
        }
        reader.readAsDataURL(input.target.files[0])
        this.uploadImg = input.target.files[0]

        const img_obj = {
          restaurantId: this.selectedRestaurant.id,
          file: this.uploadImg
        }

        this.$store.dispatch('api/uploadImageProfile', img_obj,  event => {
          this.progress = Math.round((100 * event.loaded) / event.total)
        }).then((response) => {
          this.$vs.notify({
            title: 'Image uploaded',
            text: response.data.message,
            iconPack: 'feather',
            icon: 'icon-check',
            color: 'success'
          })
          this.part3change = true
          this.$vs.loading.close()
        }).catch(err => {
          console.error(err)
          this.$vs.notify({
            title: 'Error',
            text: err.message,
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger'
          })
          this.$vs.loading.close()
        })
      }
    },
    updateCurrLogo (input) {
      if (input.target.files && input.target.files[0]) {
        const reader = new FileReader()
        reader.onload = e => {
          this.logoImg = e.target.result
        }
        reader.readAsDataURL(input.target.files[0])
        this.uploadLogoImg = input.target.files[0]

        const img_obj = {
          restaurantId: this.selectedRestaurant.id,
          file: this.uploadLogoImg
        }

        this.$store.dispatch('api/uploadLogo', img_obj,  event => {
          this.progress = Math.round((100 * event.loaded) / event.total)
        }).then((response) => {
          this.$vs.notify({
            title: 'Logo uploaded',
            text: response.data.message,
            iconPack: 'feather',
            icon: 'icon-check',
            color: 'success'
          })
          this.part3change = true
          this.$vs.loading.close()
          this.$store.commit('api/SET_SELECTED_RESTAURANT', response.data.data)
        }).catch(err => {
          console.error(err)
          this.$vs.notify({
            title: 'Error',
            text: err.message,
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger'
          })
          this.$vs.loading.close()
        })
      }
    },
    getStripeAccount () {
      const payload = {
        restaurant_id: this.selectedRestaurant.id
      }

      this.$vs.loading()
      this.$store.dispatch('api/getStripeAccount', payload).then((response) => {
        if (!response.data.status) {
          this.accountStatus = response.data.message
          this.has_account = false
          this.charges_enabled = false
          this.payouts_enabled = false
          this.stripeAccount = null
          this.selectedCard = null
        } else {
          this.accountStatus = 'Account: '
          this.stripeAccount = response.data.data
          this.has_account = true
          this.charges_enabled = this.stripeAccount.charges_enabled
          this.payouts_enabled = this.stripeAccount.payouts_enabled
          if (this.stripeAccount.external_accounts) {
            if (this.stripeAccount.external_accounts.data.length > 0) {
              this.selectedCard = this.stripeAccount.external_accounts.data[0]
            }
          }
        }

        this.$vs.loading.close()
      }).catch(err => {

        this.$vs.loading.close()
        console.error(err.message)
      })
    },
    createPaymentAccount () {
      this.$vs.loading()
      const payload = {
        restaurant_id: this.selectedRestaurant.id
      }

      this.$store.dispatch('api/createStripeAccount', payload).then((response) => {
        if (!response.data.status) {
          this.accountStatus = response.data.message
        } else {
          this.accountStatus = response.data.message
          this.open_url(response.data.data.url)
        }
        this.$vs.loading.close()
      }).catch(err => {
        console.error(err.message)
        this.$vs.loading.close()
      })
    },
    duplicateData () {
      const data = this.selectedRestaurant
      data.duplicating = true
      data.duplicating_id = data.id
      data.id = null
      this.sidebarData = data
      this.sidebarData.add = true
      this.toggleDataSidebar(true)
    },
    open_url (url) {
      if (!url.startsWith('https://')) {
        url = 'https://'.concat(url)
      }
      window.open(url, '_blank')
    }
  },
  watch: {
    '$store.state.api.selectedRestaurant' (val) {
      if (val) {
        this.handleData()
        this.show_data = true
      }
    },
    user (val) {
      if (val) {
        this.paymentModel = this.user.user_property['Payment-Model']
      }
    }
  },
  created () {
    this.getRestaurantData(this.selectedRestaurant.id)
  },
  mounted () {
    setTimeout(() => {
      this.initPlaces()
    }, 500)
    if (this.selectedRestaurant) {
      this.handleData()
      this.show_data = true
    }
  }
}
</script>

<style lang="scss">
.pad-12 {
  padding: 0 1.2rem;
}
.img-container > div {
  background-size: contain;
  background-repeat: no-repeat;
  background-position: top;
}
.img-container {
  border-radius: 50%;
}

.mobile #profile {
  &.pad-12 {
    padding: 0 !important;
  }
  .vx-col {
    padding: 0 !important;
  }
  .profile-image-wrapper {
    display: flex;
    flex-direction: column;
    text-align: center;

    .vx-col:nth-child(2) {
      .vs-con-input-label {
        text-align: left;
        margin-bottom: 10px;
      }
    }
  }
  .img-container {
    margin: 0 auto !important;
  }
}

</style>
